import { defineStore } from "pinia";
import { markRaw } from "vue";
import { watchRequest, Success, type ResultOkRef } from "../api";
import {
  ReviewsResponseSchema,
  type ReviewsResponse,
} from "../schemas/review";

class ReviewsApi {
  private readonly url = "/reviews/";
  private cached?: ResultOkRef<Success<ReviewsResponse>>;

  getReviews(lang?: string): ResultOkRef<Success<ReviewsResponse>> {
    if (!this.cached) {
      this.cached = watchRequest(
        this.url,
        ReviewsResponseSchema,
        lang ? { lang } : undefined,
      );
    }
    return this.cached;
  }
}

const store = defineStore("reviews", () => ({
  api: markRaw(new ReviewsApi()),
}));

export function useReviews() {
  return store().api;
}
